import React from 'react';
import { GridContainer, CenterContent } from 'global/components/perform-grid';
import Create from './create';

export default (props) => {
  return (
    <GridContainer>
      <CenterContent fullWidth>
        <Create />
      </CenterContent>
    </GridContainer>
  );
};
